var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlay(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.527 8.091a1 1 0 010 1.782L1.951 17.3a1 1 0 01-1.454-.891V1.557A1 1 0 011.951.666L16.527 8.09z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default "data:image/svg+xml,%3csvg width='18' height='18' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath d='M16.5273 8.0913C17.2554 8.46222 17.2554 9.50247 16.5273 9.87339L1.95097 17.2989C1.28566 17.6379 0.497051 17.1546 0.497051 16.4079L0.497051 1.5568C0.497051 0.81013 1.28566 0.326827 1.95097 0.665755L16.5273 8.0913Z' fill='white'/%3e %3c/svg%3e";
export { MemoForwardRef as ReactComponent };